interface SectionLabelProps {
  text: string;
  className?: string;
}

/**
 * Etiqueta decorativa para encabezados de sección
 * Diseño consistente en toda la aplicación
 */
export function SectionLabel({ text, className = "" }: SectionLabelProps) {
  return (
    <div className={`inline-flex items-center gap-2 bg-[#39B5BF]/10 border border-[#39B5BF]/30 text-[#2C5AA0] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-lg mb-6 shadow-sm ${className}`}>
      <span className="w-1.5 h-1.5 bg-[#39B5BF] rounded-full" />
      {text}
    </div>
  );
}
